import { useDispatch, useSelector } from "react-redux";
import { App, Form, Space, Tooltip } from "antd";
import { CloseBtn, FormUi, Modal, SaveBtn } from "../../ui";
import { NotificacionForm } from "./NotificacionForm";
import { useEffect, useRef } from "react";
import {
  notificacionStartAdd,
  notificacionStartUpdate,
} from "../../../actions";
import { parseDateFormatBackEnd } from "../../../helpers/utils";
import dayjs from "dayjs";
import { EstadoNotificacionConstants } from "../../../helpers";
const initialValues = (data = {}) => ({
  id: data?.id || null,
  mensaje: data?.mensaje || null,
  canal: data?.canal || null,
  leido: data?.leido || null,
  estado: data?.estado || EstadoNotificacionConstants.PENDIENTE,
  fechaenvio: dayjs(data?.fechaenvio) || dayjs(),
  tipo: data?.tipo || "info",
  app: data?.app || null,
  esmasivo: data?.esmasivo ?? true,
  empleadosdestinatario: data?.empleadosdestinatario || [],
});
const useResetFormOnCloseModal = ({ form, open, activeNotificacion }) => {
  const prevOpenRef = useRef(null);
  useEffect(() => {
    prevOpenRef.current = open;
  }, [open]);
  const prevOpen = prevOpenRef.current;
  useEffect(() => {
    if (!open && prevOpen) {
      form.resetFields();
    } else {
      if (activeNotificacion)
        form.setFieldsValue({
          ...activeNotificacion,
          fechaenvio: dayjs(activeNotificacion?.fechaenvio),
        });
    }
  }, [form, prevOpen, open]);
};
export const NotificacionModal = ({ openModal, onClose }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { activeNotificacion } = useSelector((state) => state.notificacion);

  useResetFormOnCloseModal({
    form,
    open: openModal,
    activeNotificacion,
  });
  const handleSave = (values) => {
    values = {
      ...values,
      fechaenvio: parseDateFormatBackEnd(values.fechaenvio),
      empleadosdestinatario: values?.empleadosdestinatario?.map((row) => ({
        empleado: row?.value,
      })),
    };
    if (activeNotificacion) {
      dispatch(notificacionStartUpdate(values));
    } else {
      dispatch(notificacionStartAdd(values));
    }
    onClose();
  };

  return (
    <Modal
      title={
        <>
          Notificación
          {activeNotificacion ? (
            <small> Editar</small>
          ) : (
            <small> Registrar</small>
          )}
        </>
      }
      open={openModal}
      onOk={handleSave}
      onCancel={onClose}
      width="40%"
      footer={[
        <CloseBtn key="salir" onClick={onClose} />,
        <SaveBtn key="guardar" htmlType="submit" form="FormNotificacion" />,
      ]}
    >
      <FormUi
        form={form}
        id="FormNotificacion"
        name="FormNotificacion"
        autoComplete="off"
        layout="vertical"
        handleSubmit={handleSave}
        initialValues={initialValues}
      >
        <NotificacionForm />
      </FormUi>
    </Modal>
  );
};
